export const normalizeString = (str) =>
  str
    ? str
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f,\-\s]/g, "")
      .replace(/\s+/g, " ")
      .trim()
    : "";